import { render, staticRenderFns } from "./IconToggleSquareV2.vue?vue&type=template&id=3d0d9f4f&"
import script from "./IconToggleSquareV2.vue?vue&type=script&lang=js&"
export * from "./IconToggleSquareV2.vue?vue&type=script&lang=js&"
import style0 from "./IconToggleSquareV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports